import NavLayout from '@components/layouts/NavLayout.tsx';
import MainNav from '@components/main-nav/MainNav.tsx';

const ScriptsOutlet = () => {
  return <NavLayout navbar={<MainNav />} />;
};

export default ScriptsOutlet;
